











import { Vue, Component, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import tournamentStore from '@/modules/tournament/tournament.store'
import { TournamentEntity } from '@/api/tournament'
import TournamentDetailsHeader from '@/modules/tournament/components/TournamentDetailsHeader'

@Component({
  components: {
    TournamentDetailsHeader
  }
})
export default class TournamentDetailsRule extends Vue {
  tournamentModule = getModule(tournamentStore, this.$store)

  /* Vuex State */
  get tournament(): TournamentEntity | null {
    return this.tournamentModule.selectedTournament
  }
}
